import type { Consent } from "@/vendors/Cookiebot/consent"

/**
 * Impression tags for tracking component visibility/rendering in Kilkaya.
 * These are sent as countable tags with nopv:1 (no page view increment).
 *
 * Format: [A-Za-z0-9_-] - Max 24 characters.
 */
export const impressionTags = {
  commentNameMissing: "cmt-name-missing",
} as const

export type ImpressionTag = (typeof impressionTags)[keyof typeof impressionTags]

export type KilkayaImpressionModel = {
  readonly tag: ImpressionTag
  readonly consent: Consent
}

export const conversionEvents = {
  acceptOfferEvent: ["buy_subscription", "offer"],
  addTrialArticleEvent: ["add_trial", "article"],
  buySubscriptionEvent: ["buy_subscription", "shop"],
  buySubscriptionEventPaywall: ["buy_subscription", "paywall"],
  buySubscriptionEventProductPage: ["buy_subscription", "productpage"],
  createProfileEvent: ["create_profile", "profile"],
  createTrialProfileEvent: ["create_trial", "profile"],
  newsletterArticleEvent: ["newsletter", "article"],
  newsletterFrontpageEvent: ["newsletter", "frontpage"],
  newsletterLandingPageEvent: ["newsletter", "landing"],
  newsletterUnderConstructionEvent: ["newsletter", "under_construction"],
} as const

export type ConversionEvent =
  (typeof conversionEvents)[keyof typeof conversionEvents]

export type ConversionModel = {
  readonly event: ConversionEvent
  readonly consent: Consent
}

/**
 * More information and properties can be found in the Kilkaya documentation:
 * https://docs.google.com/spreadsheets/d/1AtAjcZt9pznS0bEHGtu2RpK8Q5IzCY6A_0rZMtExLnA/edit?gid=0#gid=0
 */
export type KilkayaClickEvent = {
  /**
   * The position is an abreviation that Kilkaya uses to as an identifier for where the click event happened.
   *
   * Please note that Kilkaya has a limitation of 32 characters.
   *
   * A list of the allowed positions can be found here:
   *
   * [https://jira-jppol.atlassian.net/wiki/spaces/Watch/pages/3224141845/Kilkaya+Position+Abbreviations](https://jira-jppol.atlassian.net/wiki/spaces/Watch/pages/3224141845/Kilkaya+Position+Abbreviations)
   */
  readonly position: string

  /**
   * The URL where the click event should navigate to.
   */
  readonly toUrl: string

  /**
   * The current URL of the page where the click event happened.
   */
  readonly url: string
}
